import React, { useState } from 'react';
import api from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../css/AdminLogin.css';

const MemberLogin = () => {
  const [employmentNumber, setEmploymentNumber] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await api.post('/portal/login', {
        employment_number: employmentNumber.trim(),
        password: password.trim(),
      });

      if (res.data.message === 'Login successful') {
        login(res.data.token, { ...res.data.member, type: 'member' });
        navigate('/memberPortal');
      } else {
        setMessage(res.data.message);
      }
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error logging in');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">Member Portal</h2>
        <p style={{ textAlign: 'center', color: '#6b7280', marginBottom: '1.5rem', fontSize: '0.9rem' }}>
          Track your membership performance and payments
        </p>
        <form onSubmit={handleLogin} className="login-form">
          <input
            type="text"
            placeholder="Employment Number"
            value={employmentNumber}
            onChange={(e) => setEmploymentNumber(e.target.value)}
            required
            className="login-input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="login-input"
          />
          <button type="submit" className="login-button">Login to Portal</button>
        </form>
        {message && <p className="login-message">{message}</p>}
        <p style={{ textAlign: 'center', marginTop: '1rem', fontSize: '0.85rem', color: '#6b7280' }}>
          Your portal password was sent when your membership was approved.
        </p>
        <p style={{ textAlign: 'center', marginTop: '0.5rem', fontSize: '0.85rem' }}>
          <a href="/adminLogin" style={{ color: '#2b6c94' }}>Staff Login</a>
        </p>
      </div>
    </div>
  );
};

export default MemberLogin;
